<template>
  <div class="supportcompany-wrap">
    <div class="divider-content">
      <div class="divider-line"></div>
      <div class="title">支持单位</div>
      <div class="divider-line"></div>
    </div>
    <div class="logo-content">
      <div class="logo-item" v-for="item in supportCompany" :key="item.id">
        <img :src="$g.host + item.filePath" />
        <div class="title">{{ item.companyName }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    ReportData() {
      return this.$store.state.ReportData;
    },
    supportCompany() {
      return this.ReportData.supportCompany || [];
    },
  },
};
</script>

<style scoped lang="scss">
.supportcompany-wrap {
  background: #eee;
  padding: 20px;
  margin: 10px 10px 0 10px;
  border-radius: 10px;
  .divider-content {
    display: flex;
    align-items: center;
    justify-content: center;
    .divider-line {
      width: 100px;
      height: 2px;
      background: green;
    }
    .title {
      margin: 0 10px;
    }
  }
  .logo-content {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    .logo-item {
      display: flex;
      align-items: center;
      img {
        width: 55px;
        height: 55px;
      }
      .title {
        margin-left: 15px;
        font-size: 12px;
        font-weight: 600;
      }
    }
  }
}
</style>